import React from "react";
import ComplaintDescription from "./ComplaintDescription";
import "./ComplaintInfo.scss";

function ComplaintInfo() {
    return (
        <section className={'complaintInfo_container'}>
            <div className={'complaintInfo_contentWrapper'}>
                <h2 className={'complaintInfo_titleComplaint'}>What happens after I submit a complaint?</h2>
                <ComplaintDescription />
            </div>
        </section>
    );
}

export default ComplaintInfo;
